<template>
  <div>
    <v-btn :outline="!complete"
           :color="complete ? 'success' : 'primary'"
           :disabled="isDisabled"
           :loading="isLoading"
           round
           @click="selectFile">
      <div slot="loader">
        <div v-if="uploadProgress < 100">
          Uploading
          <v-progress-circular :value="uploadProgress" rotate="-90" class="my-0" size="24" />
        </div>
        <div v-else>
          Validating
          <v-progress-circular indeterminate class="my-0" size="24" />
        </div>
      </div>
      <template v-if="complete">
        Upload Complete
        <nt-icon class="ml-2">check</nt-icon>
      </template>
      <template v-else>
        {{ label || 'Upload' }}
        <nt-icon class="ml-2">cloud_upload</nt-icon>
      </template>
    </v-btn>
    <input ref="fileInput"
           type="file"
           hidden
           :accept="myFileTypes"
           @change="fileSelected" />
  </div>
</template>

<script>
  export default {
    props: [
      'label',
      'fileTypes',
      'maxFileSize',
      'confirm',
      'url',
      'disabled',
      'complete'
    ],
    data: () => ({
      isLoading: false,
      uploadProgress: 0
    }),
    computed: {
      myFileTypes() {
        return this.fileTypes != null && this.fileTypes.length ? this.fileTypes.map(x => '.' + x).join(',') : '';
      },
      isDisabled() {
        return !!this.disabled || this.isLoading;
      }
    },
    methods: {
      selectFile() {
        if (!this.complete) {
          this.$refs.fileInput.value = '';
          this.$refs.fileInput.click();
        }
      },
      fileSelected(e) {
        const file = e.target.files[0];
        if (file !== undefined) {
          if (this.maxFileSize != null && file.size > this.maxFileSize * 1048576) {
            this.$snackbar(`File Size must be less than ${this.maxFileSize} MB.`, 'error');
          } else {
            if (this.confirm === true) {
              this.$confirm({ title: 'Upload File?', text: `Do you wish to upload ${file.name}?`, yesLabel: 'Upload' })
                .then(x => {
                  if (x) {
                    this.uploadFile(file);
                  }
                });
            } else {
              this.uploadFile(file);
            }
          }
        }
      },
      uploadFile(file) {
        this.isLoading = true;
        const formData = new FormData();
        formData.append('File', file);
        this.$http.post(this.url, formData, { onUploadProgress: this.updateProgress })
          .then(x => this.$emit('file-uploaded', x))
          .catch(err => this.$emit('upload-error', err))
          .finally(() => {
            window.setTimeout(() => {
              this.isLoading = false;
              this.uploadProgress = 0;
            }, 500);
          });
      },
      updateProgress(p) {
        this.uploadProgress = (100.0 / p.total) * p.loaded;
      }
    }
  }
</script>
